import React from 'react';
import PropTypes from 'prop-types';

import Spinner from 'components/Spinner';
import { TOASTS_VARIANTS, TOASTS_TEMPLATES } from 'constants/toastTypes';
import './style.scss';

const Toast = ({ variant, template, title, description }) => (
  <div data-test={`toast_${variant}`} styleName="message-container">
    <div styleName={`header-container is-${variant}`}>
      {template === TOASTS_TEMPLATES.COMMON && <div styleName="logo" />}
      {template === TOASTS_TEMPLATES.PRELOADER && (
        <Spinner styleName="spinner" />
      )}
      <div data-test="title" styleName="title">
        {title}
      </div>
      {template !== TOASTS_TEMPLATES.PRELOADER && (
        <div data-test="close-button" styleName="close-icon" />
      )}
    </div>
    {description && (
      <div data-test="description" styleName="description">
        {description}
      </div>
    )}
  </div>
);

Toast.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  template: PropTypes.oneOf(Object.values(TOASTS_TEMPLATES)),
  variant: PropTypes.oneOf(Object.values(TOASTS_VARIANTS)),
};

Toast.defaultProps = {
  description: '',
  variant: TOASTS_VARIANTS.SUCCESS,
  template: TOASTS_TEMPLATES.COMMON,
};

export default Toast;
